/*
 * MONOLITHO CUSTOM OVERLAY CART
 * Developed by Willem Shepherd, 2012 for Monolitho, a Shopify Theme 
 * tread lightly, this code is fragile!
 */
 // Track cart activity status
isUpdating = false;
var $body = $('body')
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || theme.moneyFormat;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}


$('.add-to-cart').bind( 'click', addToCart );
$('#AddToCart-product-template').bind( 'click', addToCart );
adjustCart();
function addToCart(e){
  $(".bg-overlay").addClass("open");
  $("html,body").addClass("scroll-hidden");

  if (typeof e !== 'undefined') e.preventDefault();

  var id        = $(this).parents('form').find('[name="id"]').val();
  var quantity  = $(this).parents('form').find('[name="quantity"]').val() || 1;
  //var proptype =$(this).parents('form').find('[name="properties[Product Type]"]').val();
//  var propweight =$(this).parents('form').find('[name="properties[Weight]"]').val();
//   var propStr = '';
//   if(proptype != ''){
//     propStr += '&properties[Product Type]='+proptype;
//   }
//   if(propweight != ''){
//     propStr += '&properties[Weight]='+propweight;
//   }

//   $.ajax({ 
//     type: 'POST',
//     url: '/cart/add.js',
//     async: false, 
//     cache: false, 
//     data: 'quantity=' + quantity + '&id=' + id+propStr,
//     dataType: 'json',
//     error: addToCartFail,
//     success: updateCartaddNote,
//     cache: false 
//   });
  
    $.ajax({ 
    type: 'POST',
    url: '/cart/add.js',
    async: false, 
    cache: false, 
    data: 'quantity=' + quantity + '&id=' + id,
    dataType: 'json',
    error: addToCartFail,
    success: updateCartaddNote,
    cache: false 
  });
  
  
  
}

function updateCartaddNote(note, callback) {
  $.ajax({ 
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: thisGetUpdatedCart,
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  });

  // add alert when item added to cart.
  $('#add-to-cart-msg').html('<h3> Item added to cart! <br /><a title="view cart"><span> View cart and checkout &raquo;</span></a></h3>').fadeIn();  
}

//REMOVING AN ITEM (the X after an item)
function removecartitem(id) {
  var cart_line_item = (id);

  $.ajax({ 
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=0&line='+cart_line_item,
    async: false, 
    cache: false, 
    dataType: 'json',
    success: thisGetUpdatedCart,
    error: addToCartFail
  });

  // add alert when item added to cart.
  // add alert when item removed.
  $('#remove-from-cart-msg').html('Item removed from cart!').fadeIn();   
}
function changeItem(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        thisGetUpdatedCart(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  // console.error('PROBLEM ADDING TO CART!', response.description);  
  $('#add-to-cart-msg').addClass('error').text(response.description);
}

// Get the cart associated with the cart-info div (id)
function thisGetUpdatedCart(cart) {
  changeUpdatedCart(cart, 'cart-info');   
}

// Do all the fancy stuff.
function changeUpdatedCart(cart, cart_summary_id, cart_count_id) {
  if ((typeof cart_summary_id) === 'string') {
    var cart_summary = ('#' + cart_summary_id);
    if (cart_summary.length) {  
      // Empty Entire cart-info div so that the we are not creating 2 carts/duplicate info.
      $(cart_summary).empty();      

      // Add a table and Tbody to attach stuff to.
      //       $("<table class=addedcart><tbody id='updating_cart'></tbody></table>").appendTo(cart_summary);
      $("<div class='addedcart'><div class='right-yourcart' id='updating_cart'></div></div>").appendTo(cart_summary);

      $.each(cart, function(key, value) {

        if (key === 'items') {
          var uc = $('#' + cart_summary_id + ' #updating_cart');

          // Creates the entire table using the new item information that has been updated!
          // If you want to add a column, test it in inline-cart.liquid FIRST, then write it into the line below

          if (value.length) {
//             $.each(value, function(i, item) {   
              var item = value[0];
              var getitem_price = (item.price);
              var monetizeitemprice = formatMoney(getitem_price, '${{amount}}')

              //finds image, creates url, cartfinalimage used instead of item.image later in the table
              var imageurl = (item.image);
              var varsize = ('small');
              var matches = imageurl.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
              var cartfinalimage =  (matches[1] + '_' + varsize + '.' + matches[2]);
              var line_item = 1;
			  console.log(item);
              var stitle = (item.title).split('<br>');
              $("<div  id='product-"+item.id+"' class='cart-box "+item.handle+" item'><div id='invisible' class='cart_amount'><input class='text' type='text' size='4' name='updates"+line_item+"' id='updates_"+line_item+"' value='"+item.quantity+"' onfocus='this.select();' class='replace'/></div><div class='cart-box-img cart_image'><a href='"+item.url+"'><img class='cartimage' src='"+cartfinalimage+"'  alt='"+stitle+"' /></a></div><div class='cart-box-right'><h4 class='cart_title'><a href='"+item.url+"'>"+stitle+"</a></h4><div class='cart-btmbox'><div class='quantity-select cart_itemprice ajaxcart__qty'><button type='button' class='ajaxcart__qty-adjust ajaxcart__qty--minus icon-fallback-text inc' data-id='"+item.key+"' data-qty='"+(item.quantity-1)+"' data-line='"+line_item+"' aria-label='Reduce item quantity by one'><span class='fallback-text' aria-hidden='true'>&minus;</span></button><input class='quantity ajaxcart__qty-num' data-id='"+item.key+"' data-line='"+line_item+"' aria-label='quantity' pattern='[0-9]*' min='0' type='text' name='updates[]' value='"+item.quantity+"'><button type='button' class='ajaxcart__qty-adjust ajaxcart__qty--plus icon-fallback-text' data-id='"+item.key+"' data-line='"+line_item+"' data-qty='"+(item.quantity+1)+"' aria-label='Increase item quantity by one'><span class='fallback-text' aria-hidden='true'>+</span></button></div><span class='price__regular cart_itemprice'><span class='money'>"+monetizeitemprice+"</span></span><span class ='cart_remove'><a onClick='removecartitem("+line_item+"); return false;'>remove</a></span></div></div></div>").appendTo(uc);   


//             });
          } else {
            //Returns error if something went wrong.
            $('<li><em>The cart is empty.</em></li>');
          }
        } else {
          //This stuff is the extra informaton that is grabbed from items.
          //remove the comment tags to see what it does!
          /*  $('<dt>' + key + '</dt><dd>' + value + '</dd>').appendTo(cart_summary); */
        }
      });     
    }
  }

  // Update Cart Total Money in Cart and converts it to money format   
  var $cartTotalAmoutFooter = $('.cart_total span:first');
  var getTotalPrice = (cart.total_price);
  var monetizeTotalPrice = formatMoney(getTotalPrice, '${{amount}}')

  switch(cart.total_price){
    default:
      $cartTotalAmoutFooter.html("<span class='money'>"+monetizeTotalPrice+"</span>");
      break;
  }

  // Update Cart Total Count in Cart Title and Side Tab
  var $cartLinkText = $('.cart-link .icon:first');
  var $carttopTotal = $('#cart_tab span.count');
  var $carttitleTotal = $('#cart-title span:first');
  

  if (cart.item_count === 0) { 
    $carttopTotal.html('(0)'); 
    $cartLinkText.html('(0)'); 
    $carttitleTotal.html('(0)'); 
  } else if (cart.item_count === 1) {
    $carttopTotal.html('(1)');
    $cartLinkText.html('(1)'); 
    $carttitleTotal.html('(1)'); 
  } else {
    $carttopTotal.html('('+cart.item_count+')');
    $cartLinkText.html('('+cart.item_count+')');
    $carttitleTotal.html('('+cart.item_count+')'); 
  }  
  // Hides he pluralizer (item/items) in the inline carts title
  $('.itemshide').hide();
}
function validateQty(qty) {
  if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};
function adjustCart() {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });
}
function updateQuantity(line, qty) {
  isUpdating = true;

  // Add activity classes when changing cart quantities
  var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
    'is-loading'
  );

  if (qty === 0) {
    $row.parent().addClass('is-removed');
  }

  // Slight delay to make sure removed animation is done
  setTimeout(function() {
    changeItem(line, qty, adjustCartCallback);
  }, 250);
};

function getCart(callback) {
  jQuery.getJSON('/cart.js', function(cart) {
    if (typeof callback === 'function') {
      callback(cart);
    } else {
      thisGetUpdatedCart(cart);
    }
  });
};
function adjustCartCallback(cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      getCart(thisGetUpdatedCart);
      isUpdating = false;
    }, 150);
};


function updateCountPrice (cart) {
   var $cartTotalAmoutFooter = $('.cart_total span:first');
    var getTotalPrice = (cart.total_price);
    var monetizeTotalPrice = formatMoney(getTotalPrice, '${{amount}}')
    $cartTotalAmoutFooter.html("<span class='money'>"+monetizeTotalPrice+"</span>");
  
    var $cartLinkText = $('.cart-link .icon:first');
    var $carttopTotal = $('#cart_tab span.count');
    var $carttitleTotal = $('#cart-title span:first');
  
    if (cart.item_count === 0) { 
      $carttopTotal.html('(0)'); 
      $cartLinkText.html('(0)'); 
      $carttitleTotal.html('(0)'); 
    } else if (cart.item_count === 1) {
      $carttopTotal.html('(1)');
      $cartLinkText.html('(1)');
      $carttitleTotal.html('(1)'); 
    } else {
      $carttopTotal.html('('+cart.item_count+')');
      $cartLinkText.html('('+cart.item_count+')');
      $carttitleTotal.html('('+cart.item_count+')'); 
    }  
  
};